export const TENANT = 'uk'
export const ENVIRONMENT = 'production'
export const IS_PRODUCTION = true
export const SMARTGATEWAY_URL = 'https://uk.api.just-eat.io'

export const KEYCLOAK_API_HOST = 'https://public-partner-management-api.foodtools.io'
export const KEYCLOAK_FEATURE_STORAGE_KEY = 'keycloak'

export const IMPERSONATED_USER_TYPE = 'jet-employee'
export const PARTNER_USER_TYPE = 'restaurant'

export const KEYCLOAK_CONFIG = {
  url: 'https://access.just-eat.co.uk/auth',
  realm: 'uk',
  clientId: 'partner-centre',
}

export const KEYCLOAK_IMPERSONATION_CONFIG = {
  url: 'https://partner-access-keycloak.internal.tkwy-prod.io/auth',
  realm: 'jet',
  clientId: 'jet-employee',
}
